import apiHandler from '../core/apiHandler';
export default apiHandler('restaurant/corporate-cafeteria');
